var path = '/templates/zenclerk_s/directives/realtime/bar-chart.html';
var html = "<div class=realtime-bar-chart-container><svg class=realtime-bar-chart></svg></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/directives/realtime/bar-chart.html
// module id = 1356
// module chunks = 0